import React from "react";

const TermofUse = () => {
  return (
    <main>
      {/* Page Banner */}
      <div className="page-banner overlay">
        <picture className="media media-bg max-md:!hidden">
          <img
            src="assets/img/banner/page-banner.jpg"
            width={1920}
            height={520}
            loading="eager"
            alt="Page Banner Image"
          />
        </picture>
        <div className="page-banner-content">
          <div className="container text-center">
            <h1 className="heading text-80 fw-700 max-md:!text-[30px]">
              Terms & Conditions
            </h1>
            <ul
              className="breadcrumb list-unstyled"
            >
              <li>
                <a
                  href="/"
                  className="text text-18"
                  aria-label="Home Page"
                >
                  Home
                </a>
              </li>
              <li>
                <svg
                  width={8}
                  height={12}
                  viewBox="0 0 8 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.08929 5.40903C7.24552 5.5653 7.33328 5.77723 7.33328 5.9982C7.33328 6.21917 7.24552 6.43109 7.08929 6.58736L2.37512 11.3015C2.29825 11.3811 2.2063 11.4446 2.10463 11.4883C2.00296 11.532 1.89361 11.5549 1.78296 11.5559C1.67231 11.5569 1.56258 11.5358 1.46016 11.4939C1.35775 11.452 1.2647 11.3901 1.18646 11.3119C1.10822 11.2336 1.04634 11.1406 1.00444 11.0382C0.962537 10.9357 0.941453 10.826 0.942414 10.7154C0.943376 10.6047 0.966364 10.4954 1.01004 10.3937C1.05371 10.292 1.1172 10.2001 1.19679 10.1232L5.32179 5.9982L1.19679 1.8732C1.04499 1.71603 0.960996 1.50553 0.962894 1.28703C0.964793 1.06853 1.05243 0.859522 1.20694 0.705015C1.36145 0.550508 1.57046 0.462868 1.78896 0.460969C2.00745 0.45907 2.21795 0.543066 2.37512 0.694864L7.08929 5.40903Z"
                    fill="currentColor"
                  />
                </svg>
              </li>
              <li>
                <a role="link" aria-disabled="true" className="text text-18 active">
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <section className="py-[100px]" id="pricing">
        <div className="container">

          <div className="row">
            <div className="col-md-12 mb-4 mb-md-0">
              <p className="mb-[10px]">
                <strong>1. Definitions</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	<strong>Aarogya OPD”</strong> refers to <strong>FINCREST SOLUTIONS PRIVATE LIMITED</strong>, the provider of the Service.
                </p>
                <p className="mb-[10px]">
                  •	<strong>“You”</strong> refers to the individual or entity
                  accessing or using the Website or Service.
                </p>
                <p className="mb-[10px]">
                  •	<strong>“Content”</strong> refers to any information, data,
                  text, software, code, or other materials.
                </p>
                <p className="mb-[10px]">
                  •	<strong>“User”</strong> refers to any individual or entity who
                  accesses or uses the Website or Service.
                </p>
                <p className="mb-[10px]">
                  •	<strong>“Service Provider”</strong> refers to the independent, third-party medical professionals, doctors, and labs empanelled to fulfil requests.
                </p>
              </div>
              <p className="my-[10px]">
                <strong>2. Nature of Service & Intermediary Status</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	<strong>Technology Platform:</strong> Aarogya OPD provides a SaaS-based health-tech infrastructure.
                </p>
                <p className="mb-[10px]">
                  •	<strong>Aggregator Status:</strong> Aarogya OPD acts strictly as an Intermediary. We do not provide medical advice or treatment directly. The contract for medical service is strictly between the User and the Service Provider.
                </p>
              </div>
              <p className="my-[10px]">
                <strong>3. Use of the Website and Service</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	You may only use the Service for lawful purposes.
                </p>
                <p className="mb-[10px]">
                  •	You agree not to damage or impair the Service, interfere with other users, gain unauthorized access, or upload objectionable/unlawful content.
                </p>
                <p className="mb-[10px]">
                  •	You agree not to violate any applicable laws or regulations.
                </p>
              </div>
              <p className="my-[10px]">
                <strong>4. User Content</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	You are solely responsible for any content you upload.
                </p>
                <p className="mb-[10px]">
                  •	You grant Aarogya OPD a royalty-free license to use and distribute your content in connection with the Service.
                </p>
              </div>
              <p className="my-[10px]">
                <strong>5. Intellectual Property</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	The Website and Service are protected by copyright and trademark laws.
                </p>
                <p className="mb-[10px]">
                  •	You agree not to remove or alter proprietary notices.
                </p>
              </div>
              <p className="my-[10px]">
                <strong>6. Disclaimers</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	THE SERVICE IS PROVIDED “AS IS” WITHOUT WARRANTIES OF ANY KIND.
                </p>
                <p className="mb-[10px]">
                  •	WE DISCLAIM ALL WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
                </p>
                <p className="mb-[10px]">
                  •	<strong>MEDICAL DISCLAIMER: </strong>Aarogya OPD IS NOT RESPONSIBLE FOR CLINICAL OUTCOMES OR MEDICAL NEGLIGENCE BY THIRD-PARTY PROVIDERS.
                </p>
              </div>
              <p className="my-[10px]">
                <strong>7. Telemedicine Consent & Compliance</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	By using Tele-Consultation, you provide voluntary consent to remote care.
                </p>
                <p className="mb-[10px]">
                  •	Per Indian Telemedicine Practice Guidelines 2020, you must provide valid ID and accurate age before the session begins.
                </p>
              </div>
              <p className="my-[10px]">
                <strong>8. Pandemic & Force Majeure Exclusion</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	Aarogya OPD is not liable for failures beyond its control.
                </p>
                <p className="mb-[10px]">
                  •	<strong>Pandemic Clause:</strong>Plan benefits are <strong>not applicable or guaranteed</strong> during declared pandemics (e.g., COVID-19 or equivalent), epidemics, or natural disasters. Decision-making regarding service fulfilment during such events rests solely with Aarogya OPD.
                </p>
              </div>
              <p className="my-[10px]">
                <strong>9. Limitation of Liability & Claim Cap</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	Aarogya OPD SHALL NOT BE LIABLE FOR INDIRECT OR CONSEQUENTIAL DAMAGES.
                </p>
                <p className="mb-[10px]">
                  •	The Company’s total liability for any claim shall not exceed the Plan Price paid by the User.
                </p>
              </div>
              <p className="my-[10px]">
                <strong>10. Age Eligibility & Plan Limits</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	<strong>Group Insurance/Accident Rider:</strong> Limited to the primary holder aged 18-65 years under relevant plan(s) only.
                </p>
                <p className="mb-[10px]">
                  •	<strong>OPD Wellness Benefits:</strong> Available for members aged 0-85 years.
                </p>
              </div>
              <p className="my-[10px]">
                <strong>11. Term and Termination</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	Terms remain in effect until terminated by you or Aarogya OPD.
                </p>
                <p className="mb-[10px]">
                  •	We may terminate at any time upon written notice.
                </p>
                <p className="mb-[10px]">
                  •	You may terminate by discontinuing use of the Service.
                </p>
              </div>
              <p className="my-[10px]">
                <strong>12. Governing Law & Jurisdiction </strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	These Terms are governed by the laws of India.
                </p>
                <p className="mb-[10px]">
                  •	All disputes are subject to the exclusive jurisdiction of the courts in india
                </p>
              </div>
              <p className="my-[10px]">
                <strong>13. Entire Agreement, Severability, & Waiver</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	These Terms constitute the entire agreement.
                </p>
                <p className="mb-[10px]">
                  •	If any provision is held invalid, the remaining provisions remain in effect.
                </p>
                <p className="mb-[10px]">
                  •	No waiver of a provision shall be deemed a continuing waiver.
                </p>
              </div>
              <p className="my-[10px]">
                <strong>14. Update to Terms</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	Aarogya OPD may update Terms at any time by posting on the Website.
                </p>
                <p className="mb-[10px]">
                  •	Continued use constitutes acceptance of amended Terms.
                </p>
                <p className="mb-[10px]">
                  •	If you have any questions about these terms, please contact us at care@aarogyaopd.com
                </p>
              </div>
              <p className="my-[10px]">
                <strong>15. Grievance Redressal</strong>
              </p>
              <p className="mb-[10px]">
                •	In compliance with the Information Technology Act and DPDP Act, for any grievances, please contact our Grievance Officer:
              </p>
              <ul className="mb-[10px] pl-[20px]">
                <li className="mb-[10px]">
                  •	<strong>Email: </strong> care@aarogyaopd.com
                </li>
                <li className="mb-[10px]">
                  •	<strong>Acknowledgment: </strong> Within 72 hours of working days.
                </li>
                <li className="mb-[10px]">
                  •	<strong>Resolution: </strong> Estimated Within 45-60 days.
                </li>
              </ul>
              <p className="my-[10px]">
                <strong>16. Disclaimers</strong>
              </p>
              <ul className="mb-[10px] pl-[20px]">
                <li className="mb-[10px]">
                  •	Valid ID proof is mandatory for all consultations
                </li>
                <li className="mb-[10px]">
                  •	Processing fee will be deducted for any plan cancellations
                </li>
                <li className="mb-[10px]">
                  •	Medicine bill – 20% discount by Aarogya OPD app. Home Delivery for minimum order worth amount: ₹425/-
                </li>
                <li className="mb-[10px]">
                  •	Aarogya OPD will be responsible only for our own prescribed centres / shops for lab, medical store or health check up.
                </li>
                <li className="mb-[10px]">
                  •	For my choice (in person visit) - Doctor's prescription, Reports, reports bill and Medicine bills to be uploaded at site where applicable.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </main>

  );
};

export default TermofUse;
